import { gql } from "@apollo/client";

export const SET_RETURNED_STATUS = gql`
    mutation OrderMutation($orderIds: [Long!]!, 
                           $returnedImageS3KeysJson: [String!]!) {
        setReturnedStatus(orderIds: $orderIds, 
                        returnedImageS3KeysJson: $returnedImageS3KeysJson) {
            id
            securityRnd
            trackingNumber
            channelId
            channelOrderNumber
            orderTime
            overallStatus
            isDelivered
            isIntercepted
            isAbnormal
            expectedDeliveryTime
            deliveredAt
            deliveryAttempts
            exceptionReasonCode
            senderAddressId
            recipientAddressId
            receiverZipcode
            sortingCode
            weightKg
            volumetricWeightKg
            lengthCm
            widthCm
            heightCm
            packageValueUsd
            podReviewStatus
            podImageS3KeysJson
            exceptionImageS3KeysJson
            isDestHubArrived
            isDestWarehouseArrived
            destHubArrivedAt
            destWarehouseArrivedAt
            receivedAtHub
            deliverAt
            isComplaint
            hasManded
            isFinished
            createdAt
            updatedAt
        }
    }
`;
